<template>
	<div class="high-lights">
		<template v-if="isPc">
			<img class="high-lights-title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-highlights-en.png" alt="">
			<img class="high-lights-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-highlights.png?t=1" alt="">
		</template>
		<template v-else>
			<img class="high-lights-title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-highlights-en.png" alt="">
			<img class="high-lights-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-highlights.png?t=1" alt="">
		</template>
		<div id="high-lights1"></div>
		<div class="high-lights1" v-if="show" >
			<div class="item" v-for="(item, index) in lights" :key="index">
				<img class="icon" :src="item.icon" alt="">
				<div class="num">
					<NumberCounter :value="item.num" class="text-color-blue nums"></NumberCounter>
					<template v-if="item.other">{{ item.other }}</template>
					<span v-if="!En">{{ item.unit }}</span>
				</div>
				<div class="text">{{ item['text' + En] }}</div>
			</div>
		</div>
		<div class="high-lights2">
			<div class="swiper mySwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in highImages" :key="index"><img :src="item.src + '?x-image-process=image/resize,w_1200,limit_0'" /></div>
				</div>
			</div>
		</div>
		<div class="high-lights3">
			<div class="line">
				<div class="btns">
					<div class="btn" :class="activeIndex == 0 ? 'disabled' : ''" @click="prevFn">
						<img style="transform: rotate(180deg);" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					</div>
					<div class="btn" :class="activeIndex == (highImages.length - 3) ? 'disabled' : ''" @click="nextFn">
						<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="high-lights4">
			<div class="btns">
				<div class="btn" @click="moreFn">
					{{ $t('newbanner6') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import NumberCounter from "./NumberCounter.vue"
export default {
	name: 'news_events',
	components: {
		NumberCounter
	},
	data() {
		return {
			activeIndex: '',
			swiper: null,
			lights: [],
			highImages: [],
			show: false
		}
	},
	mounted() {
		this.getData()
		window.addEventListener('scroll', () => {
			if (($('#high-lights1').offset().top - $(document).scrollTop()) < $(window).height()) {
				this.show = true
			}
		})
	},
	methods: {
		getData() {
			protal.getJson('home_highlights', data => {
				this.lights = data.lights
				this.highImages = data.highImages

				this.$nextTick(() => {
					this.setSwiper()
				})
			})
		},
		setSwiper() {
			const that = this
			this.$nextTick(() => {
				this.swiper = new Swiper('.mySwiper', {
					autoplay: false,
					slidesPerView: this.isPc ? 3 : 1,
					spaceBetween: this.isPc ? 22 : 0,
					onTransitionEnd: function (swiper) {
						that.activeIndex = swiper.activeIndex
					},
				})
			})
		},
		prevFn() {
			this.swiper.slidePrev()
		},
		nextFn() {
			this.swiper.slideNext()
		},
		moreFn() {
			this.$router.push('/download_center#download4')
		}
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.high-lights {

		.high-lights-title {
			width: auto;
			height: 144px;
			margin: 145px 0 20px;
		}

		.high-lights1 {
			display: flex;
			justify-content: space-between;
			width: 1640px;
			margin: 20px auto 48px;

			.item {
				width: 395px;
				height: 240px;
				background: #FFFFFF;
				border-radius: 24px;
				padding: 32px 0 0 36px;

				.icon {
					width: 40px;
					height: 40px;
					margin-bottom: 30px;
				}

				.num {
					font-family: Inter, syn;
					font-weight: 400;
					font-size: 68px;
					color: #0B243F;
					line-height: 68px;
					text-align: left;
					font-style: normal;
					margin-bottom: 16px;
					display: flex;
					align-items: flex-end;

					span {
						font-family: syn;
						font-weight: 400;
						font-size: 28px;
						color: #0B243F;
						line-height: 28px;
						text-align: left;
						font-style: normal;
						margin-left: 8px;
						transform: translateY(-8px);
					}
				}

				.text {
					height: 20px;
					font-family: Inter, syn;
					font-weight: 400;
					font-size: 20px;
					color: #666666;
					line-height: 20px;
					text-align: left;
					font-style: normal;
				}
			}
		}

		.high-lights2 {
			width: 1640px;
			margin: 0 auto;
			overflow: hidden;

			.swiper-slide {

				img {
					width: 532px;
					height: 399px;
					border-radius: 24px;
				}
			}
		}

		.high-lights3 {
			width: 1640px;
			position: relative;
			margin: 66px auto 53px;
			
			.line {
				width: 1480px;
				height: 1px;
				background: rgba(11, 36, 63, 0.2);
				position: relative;
			}

			.btns {
				position: absolute;
				left: 100%;
				top: 50%;
				transform: translateY(-50%);
				display: flex;

				.btn {
					width: 68px;
					height: 68px;
					border: 1px solid rgba(22,39,69,0.3);
					border-radius: 50%;
					margin-left: 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
					}

					&.disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}
			}
		}

		.high-lights4 {
			width: 1640px;
			position: relative;
			margin: 0 auto;
			padding-bottom: 97px;

			.btns {
				display: flex;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.high-lights {
		position: relative;
		padding-top: 3.2rem;
		background-color: #F8F8F9;

		.high-lights-title {
			width: 100%;
			height: auto;
			position: absolute;
			left: 0;
			top: 1.2rem;
		}

		.high-lights1 {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			width: 100%;
			position: relative;
			z-index: 1;
			width: 6.78rem;
			margin: 0 auto;

			.item {
				width: 3.3rem;
				height: 2.4rem;
				background: #FFFFFF;
				border-radius: .28rem;
				padding: .32rem 0 0 .32rem;
				margin-bottom: .2rem;

				.icon {
					width: .4rem;
					height: .4rem;
					margin-bottom: .32rem;
				}

				.num {
					font-family: Inter, syn;
					font-weight: 400;
					font-size: .6rem;
					color: #0B243F;
					line-height: .68rem;
					text-align: left;
					font-style: normal;
					margin-bottom: .16rem;
					display: flex;
					align-items: flex-end;

					span {
						font-family: syn;
						font-weight: 400;
						font-size: .28rem;
						color: #0B243F;
						line-height: .28rem;
						text-align: left;
						font-style: normal;
						margin-left: 0.08rem;
						transform: translateY(-0.08rem);
					}
				}

				.text {
					font-family: Inter, syn;
					font-weight: 400;
					font-size: .2rem;
					color: #666666;
					line-height: .2rem;
					text-align: left;
					font-style: normal;
				}
			}
		}

		.high-lights2 {
			width: 6.78rem;
			margin: .12rem auto 0;
			overflow: hidden;

			.swiper-slide {

				img {
					width: 6.78rem;
					height: auto;
					border-radius: .24rem;
				}
			}
		}

		.high-lights3 {
			width: 6.78rem;
			position: relative;
			margin: 0.64rem auto 0.55rem;
			
			.line {
				width: 4.74rem;
				height: 1px;
				background: rgba(11, 36, 63, 0.2);
				position: relative;
			}

			.btns {
				position: absolute;
				left: 100%;
				top: 50%;
				transform: translateY(-50%);
				display: flex;

				.btn {
					width: .88rem;
					height: .88rem;
					border: 1px solid rgba(22,39,69,0.3);
					border-radius: 50%;
					margin-left: .16rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .32rem;
						height: auto;
					}

					&.disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}
			}
		}

		.high-lights4 {
			width: 6.78rem;
			position: relative;
			margin: 0 auto;
			padding-bottom: 1rem;

			.btns {
				display: flex;

				.btn {
					height: .88rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/highlights.vue